import sanityClient from '@sanity/client'

//DEV
/*export const client = sanityClient({
    projectId: 't1j3lbxt',
    dataset: 'dev',
    apiVersion: '2021-03-25',
    token:
        'skeBCS6RGlwLag7Rz7JvETUgH6dVJMR1JYj9kUH7MnrbiPkzFy0Upxx6x9KlNFPpB5VnnnnqFuL6uMMYFtZ5Vj5ZkQJ3BmZvzaywrQbGGeebs2xL1aRJe8wIhAw8ThqJc9VDFzYDBopOxSu9Jfu0HFHjFNko9MuwMLczP3kOOVNMrbLmzSuj',
    useCdn: true,
})*/

//Prod
export const client = sanityClient({
    projectId: 'oypey1ej',
    dataset: 'production',
    apiVersion: '2021-03-25',
    token:
        'skZkhBtIj5qcsHYBM2zW7lS1QmPZ1c4ZPL3git3PgJsi1dqgIZFt388Ro4V9PPl5ISxxdVcHlVpK6Fe0uFxMsu16qcs0WnLs4UNEXzdJIYbJF0OROUTMAvnDk9Whl0HqESvOiriNxFWmmNrsfvFCUKaw0o8BUd3THz6bQPDLTLAu8OfDFq4i',
    useCdn: false,
})
